import {
	TileEntityParam,
	type TileIndex,
	type TileNeighbour,
} from "@/types/tile";
import { shuffle } from "@/utils/array";
import { formatNumber } from "@/utils/format";
import { FrameName, tilerepoGrasslandFrameNames } from "../config";
import { TileVisibilityType } from "../config/terrain";
import TileEntity, {
	type TileEntityWithOnBuildMethod,
	type TileEntityWithOnTickMethod,
} from "../TileEntity";

class AppleOrchardBuildingTileEntity
	extends TileEntity
	implements TileEntityWithOnBuildMethod, TileEntityWithOnTickMethod
{
	public static readonly frameName = FrameName.APPLE_ORCHARD;

	public get description(): string {
		return super.description.replace("{number}", formatNumber(5));
	}

	public onBuild(): void {
		this.onTick();
		this.onTick();
	}

	public onTick(): void {
		if (!this.range) throw new Error("Range is not defined!");

		const neighbours = this.tilerepo
			.getNeighbourTileIndexesByTileCoordinates(
				{ x: this.x, y: this.y },
				this.range,
			)
			.map((tileIndex: TileIndex): TileNeighbour | null => {
				if (
					this.tilerepo.getParam(
						tileIndex,
						TileEntityParam.IS_BLOCKED_BY_ENEMY,
					)
				)
					return null;

				if (this.tilerepo.isTileLocked(tileIndex)) return null;

				const [tileId0, , tileId2] =
					this.tilerepo.getTileIdsByTileIndex(tileIndex);
				if (!tileId0 || tileId2) return null;

				const frameName = this.tilerepo.getFrameNameByTileId(tileId0);
				if (!frameName) return null;

				return {
					tileIndex,
					tileId: tileId0,
					frameName,
				};
			})
			.filter(
				(neighbour: TileNeighbour | null): boolean =>
					neighbour !== null &&
					this.tilerepo.getParam(
						neighbour.tileIndex,
						TileEntityParam.VISIBILITY,
					) === TileVisibilityType.EXPLORED,
			) as Array<TileNeighbour>;

		if (!neighbours.length) return;

		const targetTile = shuffle(
			neighbours.filter((neighbour: TileNeighbour): boolean =>
				tilerepoGrasslandFrameNames.has(neighbour.frameName),
			),
		).pop();
		if (!targetTile) return;

		this.tilerepo.setTileByTileCoordinates(
			this.tilerepo.getTileCoordinatesByTileIndex(targetTile.tileIndex),
			FrameName.APPLE_GROVE,
		);
	}
}

export default AppleOrchardBuildingTileEntity;
